var map = {
	"./IMG BARES.jpg": "d79c",
	"./IMG Lanchonete.png": "7ed1",
	"./IMG Padaria.jpg": "309a",
	"./IMG Vestuario.jpg": "4a99",
	"./IMG pizza.jpg": "f2b1",
	"./anel.png": "6be1",
	"./capa1.jpg": "687c",
	"./capa2.jpg": "f851",
	"./comanda.png": "0a4a",
	"./contrucao.jpg": "056d",
	"./delivery.png": "4fd1",
	"./desk.png": "d9e5",
	"./fastfood.png": "d7c2",
	"./fiscal.jpg": "e92d",
	"./fiscal.png": "c741",
	"./joia.jpg": "5284",
	"./market.png": "2449",
	"./medicina.jpg": "98ae",
	"./mesas.png": "3efe",
	"./mobile.png": "018d",
	"./office.png": "2e44",
	"./old/1.jpg": "96c8",
	"./old/10.jpg": "1143",
	"./old/11.jpg": "39e4",
	"./old/12.jpg": "2825",
	"./old/2.jpg": "06b1",
	"./old/3.jpg": "130b",
	"./old/4.jpg": "62d7",
	"./old/5.jpg": "8cb1",
	"./old/6.jpg": "5313",
	"./old/7.jpg": "d588",
	"./old/8.jpg": "e189",
	"./old/9.jpg": "68fa",
	"./old/Emissao-Cupom-Fiscal-Sat.jpg": "7ba8",
	"./old/PDV-Mini-Agil.jpg": "4da4",
	"./old/Sistema-Cloud-Nuvem.jpg": "65f9",
	"./old/Sistema-Construcao-Orcamento.jpg": "8ca9",
	"./old/Sistema-Mercado.jpg": "2574",
	"./old/Sistema-Mobile-Celular-Pizzaria.jpg": "49c1",
	"./old/Sistema-PDV-Movel.jpg": "0541",
	"./old/Sistema-Padaria-Balcao.jpg": "6a01",
	"./old/Sistema-Restaurante-Delivery.jpg": "78de",
	"./old/Sistema-Vestuario-Roupas.jpg": "5c76",
	"./old/Sistemas-MBD-Informatica.jpg": "bd4f",
	"./old/Stone-Pagamentos-Cartao.jpg": "7331",
	"./padaria.png": "36f0",
	"./pagamento onlne.jpg": "60e2",
	"./pagamento-online.png": "356c",
	"./pedreiro.png": "1e3d",
	"./pizza.png": "3acc",
	"./restaurante.png": "fcfb",
	"./sapato.png": "bd39",
	"./supermercado.png": "59ae",
	"./supermercado1.jpg": "d090",
	"./take-away.png": "875c",
	"./varejo.jpg": "1ecd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b39b";